import { createFileRoute } from "@tanstack/react-router";
import Pledges from "@/components/Pledges";
import { PageHeader } from "@/components/PageHeader";

function RouteComponent() {
  return (
    <div className="space-y-4">
      <PageHeader
        title="Pledges"
        subtitle="Non-binding indications of interest across all deals."
      />
      <Pledges />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/pledges/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
